import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=4e0dae2a&scoped=true&"
import script from "./Dictionary.vue?vue&type=script&lang=js&"
export * from "./Dictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0dae2a",
  null
  
)

export default component.exports